// 知识库权限模型，使用方式参考：https://ku.baidu-int.com/d/wbNDmEXlj8DEoa
import KuAuthority from '@/auth/KuAuthority';
import KuAuth from '@/auth/KuAuth';

export default {
    KuAuthority,
    KuAuth,
};
